import { normalizeList } from 'api/normalize';
import {
  LOAD_BOARD_SUCCESS,
  LOAD_CARD_SUCCESS,
  LoadBoardSuccessAction,
  LoadCardSuccessAction,
} from 'modules/loaders';
import { CardResponse, ListModel } from 'types';
import { createReducer } from 'util/reducers';
import { HasRequiredKeys } from 'util/types';
import uniqBy from 'util/uniqBy';
import { PERFORM_SEARCH_SUCCESS, PerformSearchSuccessAction } from './search';

// Reducer
export type ListState = ListModel[];
const initialState: ListState = [];

export default createReducer(initialState, {
  [LOAD_BOARD_SUCCESS](state, { payload }: LoadBoardSuccessAction) {
    const { lists = [] } = payload;

    return uniqBy(
      state.concat(lists.map((list) => normalizeList(list))),
      (list) => list.id,
    );
  },

  [LOAD_CARD_SUCCESS](state, { payload }: LoadCardSuccessAction) {
    if (!payload.list) {
      return state;
    }

    return uniqBy(
      state.concat([normalizeList(payload.list)]),
      (list) => list.id,
    );
  },

  [PERFORM_SEARCH_SUCCESS](state, { payload }: PerformSearchSuccessAction) {
    const { cards = [] } = payload;

    const newLists = cards
      .filter(
        ({ list, idList }) =>
          list && !state.find((existingList) => existingList.id === idList),
      )
      .map((card: HasRequiredKeys<CardResponse, 'list'>) =>
        normalizeList(card.list),
      );

    return state.concat(newLists);
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/lists.ts